<template>
  <div class="modal">
    <div class="container modal-container">
      <button @click="closeModal" class="modal-close">
        <i class="fas fa-times text-2xl"></i>
      </button>
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import modalMixin from '../../../mixins/modal-mixins'

export default {
  name: 'BaseAlertModal',
  mixins: [modalMixin]
}
</script>

<style scoped>
.modal {
  @apply border-solid border-black border-2 mx-auto;
  margin-top: 55px;
  left: 50%;
  transform: translateX(-50%);
}

.modal-close {
  @apply relative mt-0 mr-0 w-full text-right
}
.modal-container {
  @apply static mt-0
}
</style>
